/**
 * @generated SignedSource<<8f363e528436301c0205942208915e96>>
 * @relayHash 99578bf583b0a9a56be79fa78a576d2a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 044735f0d66e4963dab26419d4a919dee4441b6ef9243c77e0162c80353dd00b

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraBoardSwimlaneStrategy = "ASSIGNEE_UNASSIGNED_FIRST" | "ASSIGNEE_UNASSIGNED_LAST" | "CUSTOM" | "EPIC" | "ISSUE_CHILDREN" | "ISSUE_PARENT" | "NONE" | "PARENT_CHILD" | "PROJECT" | "REQUEST_TYPE" | "%future added value";
export type JiraIssueSearchOperationScope = "NIN_GLOBAL" | "NIN_GLOBAL_SCHEMA_REFACTOR" | "NIN_GLOBAL_SHADOW_REQUEST" | "NIN_PROJECT" | "NIN_PROJECT_SCHEMA_REFACTOR" | "NIN_PROJECT_SHADOW_REQUEST" | "TIMELINE_PROJECT" | "%future added value";
export type JiraJqlScopeInput = {
  backlog?: JiraJqlBacklogInput | null | undefined;
  board?: JiraJqlBoardInput | null | undefined;
  list?: JiraIssueSearchScope | null | undefined;
  plan?: JiraJqlPlanInput | null | undefined;
};
export type JiraJqlBacklogInput = {
  boardId: AGG$Long;
};
export type JiraJqlBoardInput = {
  boardId: AGG$Long;
  swimlaneStrategy?: JiraBoardSwimlaneStrategy | null | undefined;
};
export type JiraIssueSearchScope = {
  operationScope?: JiraIssueSearchOperationScope | null | undefined;
  projectKey?: string | null | undefined;
};
export type JiraJqlPlanInput = {
  planId: AGG$Long;
  scenarioId?: AGG$Long | null | undefined;
};
export type FilterPopupContentEntryPointQuery$variables = {
  cloudId: string;
  jqlContext?: string | null | undefined;
  scope?: JiraJqlScopeInput | null | undefined;
};
export type FilterPopupContentEntryPointQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"FilterPopupContentEntryPoint">;
};
export type FilterPopupContentEntryPointQuery = {
  response: FilterPopupContentEntryPointQuery$data;
  variables: FilterPopupContentEntryPointQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcrefactorfilterrefinementbasiccomponentrelayprovider": refactorFilterRefinementBasicComponentEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcrefactorfilterrefinementbasiccomponentrelayprovider: {
    readonly get: () => boolean;
  };
});

import refactorFilterRefinementBasicComponentEnabled_provider from '@atlassian/jira-relay-provider/src/refactor-filter-refinement-basic-component.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jqlContext"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scope"
},
v3 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v4 = {
  "kind": "Variable",
  "name": "jqlContext",
  "variableName": "jqlContext"
},
v5 = {
  "kind": "Variable",
  "name": "scope",
  "variableName": "scope"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "FilterPopupContentEntryPointQuery",
    "selections": [
      {
        "args": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "FilterPopupContentEntryPoint"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcrefactorfilterrefinementbasiccomponentrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "FilterPopupContentEntryPointQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              (v3/*: any*/)
            ],
            "concreteType": "JiraJqlBuilder",
            "kind": "LinkedField",
            "name": "jqlBuilder",
            "plural": false,
            "selections": [
              {
                "args": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "kind": "LinkedField",
                "name": "fields",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "concreteType": "JiraJqlFieldEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraJqlField",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "displayName"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "jqlTerm"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "type"
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    "type": "JiraJqlFieldConnection"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "044735f0d66e4963dab26419d4a919dee4441b6ef9243c77e0162c80353dd00b",
    "metadata": {},
    "name": "FilterPopupContentEntryPointQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcrefactorfilterrefinementbasiccomponentrelayprovider": refactorFilterRefinementBasicComponentEnabled_provider
    }
  }
};
})();

(node as any).hash = "4212ddb4dc4aef187cf0f891a64149b0";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
